import React from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { AddStandardPayoutMethod } from "./AddStandardPayoutMethod";
import { PaymentMethodsDashboard } from "./PaymentMethodsDashboard";
import { PayoutMethodInternational } from "./PayoutMethodInternational";
import { ReplaceInstantPayoutMethod } from "./ReplaceInstantPayoutMethod";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { AddInstantPayoutMethod } from "./AddInstantPayoutMethod";

export const PaymentMethods: React.FC = () => {
  const history = useHistory();
  const basePath = "/member/settings/payment-methods";
  const featureFlagQuery = useFeatureFlags();

  return (
    <Switch>
      <Route
        path={basePath + "/standard/add"}
        render={() => (
          <AddStandardPayoutMethod
            basePath={basePath + "/standard/add"}
            onBack={() => {
              history.push(basePath);
            }}
            onFinish={() => {
              history.push(basePath);
            }}
          />
        )}
      />
      {featureFlagQuery.data?.rtpAccounts ? (
        <Route
          path={basePath + "/instant/add"}
          render={() => (
            <AddInstantPayoutMethod
              basePath={basePath + "/instant/add"}
              onBack={() => {
                history.push(basePath);
              }}
              onFinish={() => {
                history.push(basePath + "/instant");
              }}
            />
          )}
        />
      ) : (
        <Route
          path={basePath + "/instant/replace"}
          render={() => (
            <ReplaceInstantPayoutMethod
              onBack={() => {
                history.push(basePath);
              }}
              onFinish={() => {
                history.push(basePath);
              }}
            />
          )}
        />
      )}
      <Route
        path={basePath + "/international"}
        component={PayoutMethodInternational}
      />
      <Route path={basePath} component={PaymentMethodsDashboard} />
    </Switch>
  );
};
